import React from 'react';
import ColorTag from './ColorTag';
var ColorTagYoungPeople1517 = function (props) {
    return React.createElement(ColorTag, { className: "ColorTagYoungPeople1517", color: "pastelPurple" }, props.useAbbr ? '15-17' : 'Young People 15–17');
};
export default ColorTagYoungPeople1517;
